import { productsForSubscriptionType } from 'district-ui-client/domain/product'
import { SelectBox } from 'district-ui-client/components/select-box'
import { service } from '@ember/service'
import { t } from 'ember-intl'
import Component from '@glimmer/component'
import type { IntlService } from 'ember-intl'
import type { Product } from 'district-ui-client/domain/product'
import type { SelectOption } from '@blakeelearning/ember-select'
import type { SubscriptionType } from 'district-ui-client/domain/subscription-type'
import type ReportRegistryService from 'district-ui-client/services/report-registry'

interface ProductPickerSignature {
  Args: {
    subscriptionType?: SubscriptionType
    selected?: Product
    onProductChange: (opt: SelectOption) => void
  }
}

export class ProductPicker extends Component<ProductPickerSignature> {
  @service intl!: IntlService

  @service reportRegistry!: ReportRegistryService

  get products(): Product[] {
    return this.args.subscriptionType ? productsForSubscriptionType(this.args.subscriptionType) : []
  }
  /**
   * Display product options for the subscription type, that we have reports for
   */
  get productsAsOptions() {
    return this.products
      .filter((product) => this.reportRegistry.reportPathsForProduct(product).length)
      .map((product) => ({ label: this.intl.t('products.' + product), value: product }))
  }

  get isDisabled() {
    // disable the picker if there is only one option and it is the selected option
    // this is to prevent the user from pointlessly clicking the picker
    return this.products.length === 1 && this.products[0] === this.args.selected
  }

  <template>
    <label class="flex flex-col gap-y-1" data-test-product-picker>
      <span class="text-sm font-medium text-neutral-250">{{t "program"}}</span>
      <SelectBox
        @disabled={{this.isDisabled}}
        @style="subtle"
        @options={{this.productsAsOptions}}
        @value={{@selected}}
        @onSelect={{@onProductChange}}
      />
    </label>
  </template>
}
